import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";

import { SlhCoreLanguageIcon } from "@slhuicore/language-icon";
import { style } from "./assets/language-icon.generated-style";

/**
 * The language icon component is a language information element.
 *
 * @CustomElement slh-language-icon
 *
 * @cssprop --slh-default-font-family - Font family.
 * @cssprop --slh-base-xs-font-size - Font size.
 * @cssprop --slh-base-bold-font-weight - Font weight.
 * @cssprop --slh-base-xxs-line-height - Line height.
 * @cssprop --slh-color-neutral-shade-00 - Font color.
 * @cssprop --slh-color-neutral-shade-40 - Background color.
 *
 * ** slots
 * @slot default - language text
 */
@customElement("slh-language-icon")
export default class SlhLanguageIcon extends SlhCoreLanguageIcon(LitElement) {
  static styles = style;
}
